module.exports = __webpack_public_path__ + "static/img/ic_fengli.b2171e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ic_fengli.png
// module id = e5kA
// module chunks = 1